module.exports = __webpack_public_path__ + "img/horizontal_3_2_r_pp2_8019.8961f6bb.png";